import React from 'react';
import Overlay from 'shared/styles/components/Overlay';

const PageOverlay = ({ isVisible, toggle }) => (isVisible ? <Overlay onClick={toggle} /> : null);

export default PageOverlay;
